import * as React from 'react';

import { Image, Typography } from "components";
import { formatAmount, getShortName } from 'utils';

import { Currency } from 'enums';
import { Size } from 'types';
import { useStyles } from './Profile.styles';

type ProfileProps = {
  size?: Size;
  img?: string;
  name?: string;
  selected?: boolean;
  amount?: number;
  subtitle?: string;
  hasAmount?: boolean;
  currency?: Currency;
  hasParticipant: boolean;
  onClick?(): void;
};

const Profile: React.FC<ProfileProps> = ({
  img,
  name,
  amount,
  subtitle,
  size = 'small',
  selected = false,
  hasAmount = false,
  currency = Currency.UAH,
  hasParticipant= false,
  onClick,
}) => {
  const styles = useStyles({
    size,
    selected,
    hasParticipant,
    amount: Number(amount),
  });

  return (
    <section className={styles.root} onClick={onClick}>
      <section className={styles.container}>
        <section className={styles.image}>
          {img && <Image src={img} skeletonType="circle" />}
          {!img && name && (
            <div className={styles.placeholder}>
              <Typography textColor="white" className={styles.shortName}>
                {getShortName(name)}
              </Typography>
            </div>
          )}
        </section>
        {hasAmount && (
          <section className={styles.amount}>
            <Typography className={styles.count}>
              <>
                {formatAmount({ amount: Number(amount) })} {currency}
              </>
            </Typography>
          </section>
        )}
      </section>
      <Typography className={styles.name} align="center">
        {name}
      </Typography>
      {subtitle && (
        <section className={styles.description}>
          <Typography className={styles.text}>
            {subtitle}
          </Typography>
        </section>
      )}
    </section>
  );
};

export default Profile;
